import { default as app, collapsibleHeaderClickEvent, onWindowResize, resetSelectionColumn, ToggleYellowToGreen, ToggleGreenToYellow, IsUndefinedOrNull } from '@legacy/App';

app.factory('CustomerDataAreaFactory', ['$http', 'settings', function ($http, settings) {
    return {
        getDataAreaList: function (lookup) {
            return $http.get(settings.ApiURL + settings.DataAreaURL + "/list/" + lookup);
        },
        getDataAreaByID: function (id) {
            return $http.get(settings.ApiURL + settings.DataAreaURL + "/customertype/" + id);
        },
        saveDataArea: function (dataArea) {
            return $http.put(settings.ApiURL + settings.DataAreaURL + "/customertype", dataArea);
        },
        deleteDataArea: function (id) {
            return $http.delete(settings.ApiURL + settings.DataAreaURL + "/" + id);
        },
        getNewDataArea: function () {
            return $http.get(settings.ApiURL + settings.DataAreaURL + "/newdataarea");
        }
    };
}]);

app.controller('CustomerDataAreaController', function ($q, $scope, CustomerDataAreaFactory, $rootScope, settings, masterFactory) {
    $rootScope.pageTitle = "Data Areas";    
    $scope.dataAreas = [];
    $scope.dataArea = {};
    $scope.newdataArea = {};
    $scope.selectedDataArea = -1;
    $scope.error = "";
    $scope.modelState = [];
    $scope.isFormVisible = false;
    $scope.pageSize = 20;

    // Initialization - this runs on load
    var init = function (pageIndex) {
        masterFactory.verifyAuthentication();        

        $('#loadingModal').modal({ backdrop: 'static' });
        $q.all([
            masterFactory.getCountryList().success(function (data) {
                $scope.countries = data;
            }).error(function (data, status) {
                masterFactory.setError(status, 'Error on loading Countries: ' + data, $scope);
            }),
            masterFactory.getCustomerTypeList().success(function (data) {
                $scope.customerTypes = data;
            }).error(function (data, status) {
                masterFactory.setError(status, 'Error on loading Customer Types: ' + data, $scope);
            }),
            CustomerDataAreaFactory.getNewDataArea().success(function (data) {
                $scope.newdataArea = data;
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            })
        ]).then(function () {
            CustomerDataAreaFactory.getDataAreaList(0).success(function (data) {
                $scope.dataAreas = data;
                $scope.refreshGrid(0);
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            }).finally(function () {
                $('#loadingModal').modal('hide');
            });
        });


    };

    init(0);

    // Grid renderers
    $scope.refreshGrid = function (pageIndex) {
        $('#gridDataArea').dxDataGrid({
            dataSource: {
                store: {
                    data: $scope.dataAreas,
                    type: 'array',
                    key: 'Id'
                }
            },
            noDataText: "No Data Areas Found",            
            showColumnLines: true,
            showRowLines: false,
            showBorders: true,
            rowAlternationEnabled: false,
            contentReadyAction: grdReadyAction,
            selection: { mode: 'single' },
            paging: {
                pageSize: $scope.pageSize,
                pageIndex: pageIndex
            },
            pager: {
                showPageSizeSelector: true,
                allowedPageSizes: [10, 20, 30]
            },
            filterRow: {
                visible: true
            },
            groupPanel: {
                visible: false,
            },
            columns: [
               {
                   caption: 'Data Area No',
                   dataField: 'Number',
                   cssClass: 'Number',
                   dataType: 'string',
                   alignment: 'center',
                   width: 150
               },
               {
                   caption: 'Data Area Name',
                   dataField: 'Name',
                   cssClass: 'Name',
                   dataType: 'string',
                   alignment: 'center',
                   cellTemplate: function (container, options) {
                       $('<span />')
                       .text(options.data.Name)
                       .appendTo(container);
                       container.addClass('grid-cell-align-left');
                   }
               }
            ],
            selectionChanged: function (selectedRowsInfo) {
                $scope.error = "";
                if (selectedRowsInfo.selectedRowsData[0] != null) {
                    $('#loadingModal').modal({ backdrop: 'static' });
                    CustomerDataAreaFactory.getDataAreaByID(selectedRowsInfo.selectedRowsData[0].Id).success(function (data) {
                        $scope.dataArea = data;
                        $scope.refreshCustomerSettings();
                        $scope.isFormVisible = true;
                        $scope.isDeleteVisible = true;
                        ToggleYellowToGreen();
                        $rootScope.pageTitle = "Data Area";
                    }).error(function (data, status) {
                        masterFactory.setError(status, data, $scope);
                    }).finally(function () {
                        $('#loadingModal').modal('hide');
                    });
                }
            }

        });
    };

    $scope.refreshCustomerSettings = function () {
        $('#gridCustomerSettings').dxDataGrid({
            dataSource: $scope.dataArea.CustomerTypePostcodes,
            columns: [
                {
                    caption: 'Customer Type',
                    dataField: 'CustomerTypeId',
                    //validationRules: [{ type: 'required' }],
                    alignment: 'center',
                    width: '30%',
                    lookup: {
                        dataSource: $scope.customerTypes,
                        displayExpr: 'Name',
                        valueExpr: 'Id'
                    }
                },
                {
                    caption: 'Country',
                    dataField: 'CountryId',
                    //validationRules: [{ type: 'required' }],
                    width: '30%',
                    alignment: 'center',
                    lookup: {
                        dataSource: $scope.countries,
                        displayExpr: 'Name',
                        valueExpr: 'Id'
                    }
                },
                {
                    caption: 'ZIP Code From',
                    dataField: 'PostcodeFrom',
                    //validationRules: [{ type: 'required' }],
                    dataType: 'number',
                    width: '20%',
                    alignment: 'center'
                },
                {
                    caption: 'ZIP Code To',
                    dataField: 'PostcodeTo',
                    //validationRules: [{ type: 'required' }],
                    dataType: 'number',
                    width: '20%',
                    alignment: 'center'
                }
            ],            
            editing: {
                editEnabled: true,
                insertEnabled: true,
                removeEnabled: true
            },
            filterRow: {
                visible: false
            },
            groupPanel: {
                visible: false,
            },
            height: 470,
            pager: {
                showPageSizeSelector: true,
                allowedPageSizes: [10, 20, 30]
            },
            paging: {
                pageSize: 30
            },
            sorting: {
                mode: 'none'
            },
            rowAlternationEnabled: false,
            rowInserted: function (rowInfo) {
                rowInfo.data.Id = -1;
            },
            selection: { mode: 'single' },
            showColumnLines: true,
            showRowLines: false,
            showBorders: true
        }).dxDataGrid('instance');

        var grd = document.getElementById("gridCustomerSettings");
        if (grd.getElementsByClassName("dx-datagrid-header-panel")[0].childNodes.length == 1)
            $('<span > Customer Settings </span>').appendTo(grd.getElementsByClassName("dx-datagrid-header-panel")[0]);
    };

    // Button click functions and submit form function
    $scope.addNewEntity = function () {
        $rootScope.pageTitle = "New Data Area";
        $scope.isFormVisible = true;
        $scope.isDeleteVisible = false;
        $scope.dataArea = angular.copy($scope.newdataArea);
        $scope.dataArea.CustomerTypePostcodes = [];        
        $scope.refreshCustomerSettings();
        ToggleGreenToYellow();
    };

    $scope.confirmDeleteEntity = function () {
        $('#DeleteModal').modal({ backdrop: 'static' });
    };

    $scope.deleteEntity = function (value) {
        if (value == 0) {
            $('#DeleteModal').modal('hide');
        }
        else if (value == 1) {
            CustomerDataAreaFactory.deleteDataArea($scope.dataArea.Id).success(function (data) {
                CustomerDataAreaFactory.getDataAreaList(0).success(function (data) {
                    var dataGrid = $('#gridDataArea').dxDataGrid('instance');
                    var pageIndex = dataGrid.pageIndex();
                    $scope.pageSize = dataGrid.pageSize();
                    $scope.dataAreas = data;
                    $scope.cancelForm();
                    $scope.refreshGrid(pageIndex);
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }).finally(function () {
                    $scope.notify.add({ type: 'success', title: 'Success!', body: 'Deleted Data Area successfully' });
                });
                
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            }).finally(function () {
                $('#DeleteModal').modal('hide');
            });
        }
    };

    $scope.cancelForm = function () {
        var dataGrid = $('#gridDataArea').dxDataGrid('instance');
        dataGrid.clearSelection();             
        $scope.isFormVisible = false;        
        $scope.customerDataAreaForm.submitted = false;
        $scope.closeModelStateErrors();
        $scope.closeAlert();
    };

    $scope.reset = function (type) {
        if (type == 'update') { // get db bankaccount and set to scope.bankaccount.            
            $('#loadingModal').modal({ backdrop: 'static' });            
            CustomerDataAreaFactory.getDataAreaByID($scope.dataArea.Id).success(function (data) {
                $scope.dataArea = data;
                $scope.refreshCustomerSettings();
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            }).finally(function () {
                $('#loadingModal').modal('hide');
            });
        }
        else {
            angular.copy($scope.newdataArea, $scope.dataArea);
            $scope.refreshCustomerSettings();
        }   
        
        $scope.customerDataAreaForm.$setPristine();
        $scope.customerDataAreaForm.submitted = false;
        $scope.closeModelStateErrors();
        $scope.closeAlert();
        $scope.notify.add({ type: 'success', title: 'Success!', body: 'Data Area details were reset' });        
    };

    $scope.submitForm = function () {
        if ($scope.customerDataAreaForm.$valid) {
            $scope.saveCustomerDataArea();
            $scope.customerDataAreaForm.submitted = false;
        } else {
            $scope.customerDataAreaForm.submitted = true;
        }
    };

    $scope.saveCustomerDataArea = function () {
        if (IsUndefinedOrNull($scope.dataArea.Id) || $scope.dataArea.Id <= 0) {
            $scope.dataArea.Id = -1;
        }        
        CustomerDataAreaFactory.saveDataArea($scope.dataArea).success(function (data) {
            CustomerDataAreaFactory.getDataAreaList(0).success(function (data) {
                var dataGrid = $('#gridDataArea').dxDataGrid('instance');
                var pageindex = dataGrid.pageIndex();
                $scope.pageSize = dataGrid.pageSize();
                $scope.dataAreas = data;
                if ($scope.dataArea.Id > 0) {
                    $scope.refreshGrid(pageindex)
                }
                else {
                    $scope.cancelForm();
                    $scope.refreshGrid(pageindex);
                }
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            }).finally(function () {
                if ($scope.dataArea.Id > 0) {
                    $scope.notify.add({ type: 'success', title: 'Success!', body: 'Updated Data Area successfully' });
                }
                else {
                    $scope.notify.add({ type: 'success', title: 'Success!', body: 'Created Data Area successfully' });
                }
            });                           
        }).error(function (data, status) {
            masterFactory.setError(status, data, $scope);
        }).finally(function () {            
        });
    }

    // Helping functions and events
    $(window).resize(function () {
        onWindowResize('#gridDataArea', settings.GridMarginHeight);
    });

    function grdReadyAction(e) {
        onWindowResize('#gridDataArea', settings.GridMarginHeight);
    }

    collapsibleHeaderClickEvent($scope);

    $scope.closeAlert = function () {
        $scope.error = null;
    };    

    $scope.closeModelStateErrors = function () {
        $scope.modelState = [];
    };

    $scope.filter = function (input, id) {
        var i = 0, len = input.length;
        for (; i < len; i++) {
            if (+input[i].Id == +id) {
                return input[i];
            }
        }
        return null;
    };

    $scope.clickHalfDiv = function (control) {
        masterFactory.setFocus(control);
    };

});